import React from 'react';
import styled from 'styled-components';

import { Styling, Colors } from '../../constants';

const HorizontalSeparator = styled.div<ISeparatorProps>`
  height: 1px;
  width: 100%;
  background-color: ${(props) => props.color};
`;

const VerticalSeparator = styled.div<ISeparatorProps>`
  height: 18px;
  width: 1px;
  background-color: ${(props) => props.color};
  margin-left: ${Styling.DEFAULT_SPACING}px;
  margin-right: ${Styling.DEFAULT_SPACING}px;
  margin-top: ${(props) => ((props.marginTop) ? `${props.marginTop}px` : 0)};
`;

interface IOwnProps {
  horizontal: boolean
}

interface ISeparatorProps {
  color: string,
  marginTop?: number
}

type IProps = ISeparatorProps & IOwnProps;

const component: React.FC<IProps> = (props: IProps) => {
  const { horizontal, ...separatorProps } = props;

  return horizontal ? <HorizontalSeparator {...separatorProps} /> : <VerticalSeparator {...separatorProps} />;
};

export default component;
